import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {ResponseDTO, HttpService, GetInvoiceCurentDTO} from '@/shared';
import {
  ConfirmPaidDTO,
  DetailInvoiceDTO,
  ExportExcelDetailInvoiceDTO,
  GetListInvoiceDTO,
} from '@/shared';
import {IResponseInvoiceCurrent, IResponseInvoiceList} from '@/types';

@Service()
export class InvoiceService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getListInvoiceList(
    getListInvoiceDTO: GetListInvoiceDTO,
  ): Promise<ResponseDTO<IResponseInvoiceList>> {
    return this.httpService.request(getListInvoiceDTO);
  }
  public async detailInvoice(
    detailInvoiceDTO: DetailInvoiceDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(detailInvoiceDTO);
  }
  public async confirmPaid(
    confirmPaidDTO: ConfirmPaidDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(confirmPaidDTO);
  }
  public async exportExcelDetailInvoice(
    exportExcelDetailInvoiceDTO: ExportExcelDetailInvoiceDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(exportExcelDetailInvoiceDTO);
  }
  public async getInvoiceCurrent(
    getInvoiceCurentDTO: GetInvoiceCurentDTO,
  ): Promise<ResponseDTO<IResponseInvoiceCurrent>> {
    return this.httpService.request(getInvoiceCurentDTO);
  }
}
